var render, staticRenderFns
import script from "./CustomVSelect.vue?vue&type=script&lang=js"
export * from "./CustomVSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomVSelect.vue?vue&type=style&index=0&id=3f284822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f284822",
  null
  
)

export default component.exports